import React from 'react';

const PageDefaultsContext = React.createContext();

export default PageDefaultsContext;
